<template>
    <v-container>
        <v-flex>
            <v-layout row class="my-2">
                <v-flex class="hidden-sm-and-down">
                    <h2>{{txc.title}}</h2>
                </v-flex>
                <v-flex class="new-button">
                    <button
                        small
                        flat
                        outline
                        class="secondary-hit right"
                        @click="paymentDialog = true"
                    >{{txc.add_payment}}</button>
                </v-flex>
            </v-layout>
            <template>
                <div v-for="(saved, index) in savedPayments" :key="index">
                    <v-card flat class="mb-2" v-bind:key="saved.ccToken">
                        <v-card-text>
                            <div v-if="saved.defaultPayment" class="violator">{{sharedStrings.generic.default}}</div>
                            <v-layout justify-space-between v-bind:class="{ 'mt-4': saved.defaultPayment }">
                                <v-flex xs2 lg1>
                                    <div class="card-icon mt-2" v-bind:class="saved.class"></div>
                                </v-flex>
                                <v-flex xs9 lg10>
                                    <div>{{saved.paymentName}}</div>
                                    <div>
                                        {{saved.paymentTypeDescription}} ****
                                        <strong>{{saved.lastFour}}</strong>
                                    </div>
                                    <div class="grey--text">{{txc.expires}} {{saved.expMonth}}/{{saved.expYear}}</div>
                                </v-flex>
                                <v-flex xs1 lg1 class="text-right">
                                    <div class="right" @click="deleteSavedPayment(saved)">
                                        <span class="icon icon-trashcan clickable"></span>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    <h5
                        v-if="saved.defaultPayment"
                        class="cardSectionTitle"
                        v-bind:key="index"
                    >{{txc.other_payments}}</h5>
                </div>
            </template>
            <add-payment-dialog
                v-if="paymentDialog"
                :payTypes="payTypes"
                @addPaymentCard="addCard"
                @closeDialog="paymentDialog = false"
            />
        </v-flex>
    </v-container>
</template>

<script>
import { PaymentType, PaymentService } from '@nuskin/ns-shop';
import * as ruleSet from '../repositories/globalRules.js';
import AddPaymentDialog from './forms/AddPaymentDialog';
import { mapGetters } from 'vuex';
import paymethodHelper from '../helpers/components/paymethods';

export default {
    name: 'PaymentMethods',
    components: {
        AddPaymentDialog
    },
    data() {
        return {
            ruleSet,
            name: '',
            number: '',
            formValid: true,
            scToastTrigger: true,
            scToastType: true,
            payTypes: [],
            savedPayments: [],
            selectedType: 'default',
            typeIds: [],
            paymentDialog: false,
            paymentMethods: '',
            paymentObj: {},
            hasCedyna: false
        };
    },
    computed: {
        ...mapGetters({
            fullscreen: 'mobileView',
            txc: 'translationsPayment',
            sharedStrings: 'sharedStrings'
        })
    },
    methods: {
        addCard(data) {
            paymethodHelper.addCard(this,data);
        },
        getPayMethods() {
            paymethodHelper.getPayMethods(this,PaymentService);
        },
        getSavedPayments() {
            paymethodHelper.getSavedPayments(this,PaymentService);
        },
        deleteSavedPayment(payment) {
            paymethodHelper.deleteSavedPayment(this,payment,PaymentService);
        },

        getTypeById(id) {
            paymethodHelper.getTypeById(id,PaymentType);
        },

        getActiveType(type) {
            return paymethodHelper.getActiveType(this,type);
        },
        cardClass(id) {
            return paymethodHelper.cardClass(this,id);
        }
    },
    mounted() {
        paymethodHelper.mounted(this);
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cardBlock {
  display: inline-block;
  margin-right: 1em;
}

.card-icon {
  width: 37px;
  height: 23px;
  background: url("../assets/icons/payment/default.svg") no-repeat;
  background-size: contain !important;
  transition: all 0.25s ease-in-out;

  &.little {
    width: 45px;
    height: 30px;
    display: inline-block;

    &:not(.active) {
      opacity: 0.25;
    }
  }

  &.visa {
    background: url("../assets/icons/payment/visa.svg") no-repeat;
  }

  &.mc {
    background: url("../assets/icons/payment/mastercard.svg") no-repeat;
  }

  &.amex {
    background: url("../assets/icons/payment/amex.svg") no-repeat;
  }

  &.dine {
    background: url("../assets/icons/payment/diners.svg") no-repeat;
  }

  &.alip {
    background: url("../assets/icons/payment/alipay.svg") no-repeat;
  }

  &.disc {
    background: url("../assets/icons/payment/discover.svg") no-repeat;
  }

  &.jcb {
    background: url("../assets/icons/payment/jcb.svg") no-repeat;
  }
}

.last-four {
  max-width: 120px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;

  &.active {
    text-decoration: underline;
  }
}

a {
  color: #272525;
  font-weight: bold;
}
</style>
